import React, { useState, useRef, useMemo, useEffect } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  interruptStateRecoil,
} from '../../atom/ModalAtom';
import { userIdState } from '../../atom/TokenAtom';
import { EntryListsDto, RoomInforDto } from '../../model/room.dto';
import { MyInforDto } from '../../model/user.dto';
import { socketio } from '../../api/socket.api';
import eventbus from '../../api/eventbus';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

interface InterruptProps {
  pickLineId: number | null;
  myInfors: MyInforDto | null;
  roomInfor: RoomInforDto | null;
  onListUpdate: () => void;
}

const Interrupt = ({
  pickLineId,
  myInfors,
  roomInfor,
  onListUpdate,
}: InterruptProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const setModalState = useSetRecoilState(interruptStateRecoil);

  const userSelectBoxRef = useRef<HTMLSelectElement>(null);

  const [entryLists, setEntryLists] = useState<EntryListsDto | null>(null);

  let nowOrderTurn =
    entryLists?.find((list) => list.userId === userId)?.turn ?? 0;
  const interruptOrderTurns = entryLists
    ?.filter((list) => list.turn !== nowOrderTurn)
    .map((list) => list.turn);

  const [interruptOrderTurn, setInterruptOrderTurn] = useState('');

  const getEntryLists = async () => {
    const response = await roomAPI.getEntryLists(Number(pickLineId));
    setEntryLists(response.data);
  };

  const handleUserSelectBoxChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setInterruptOrderTurn(e.target.value);
    userSelectBoxRef.current?.classList.add('selected');
  };

  const handleConfirm = async () => {
    if (myInfors?.userNumber === '') {
      setError('입력된 번호가 없어서\n입차가 불가합니다.');
      return;
    }
    if (interruptOrderTurn === '') {
      setError(blankMsg);
      return;
    }
    if (!nowOrderTurn) {
      nowOrderTurn = Number(interruptOrderTurns?.length) + 1;
      const handleEntrance = async (lineId: number) => {
        try {
          await roomAPI.postEntrance(lineId);
        } catch (err: any) {
          setError('이미 입차가 되어있습니다.');
        }
      };
      await handleEntrance(Number(pickLineId));
    }
    if (roomInfor?.lines.find((line) => line.id === pickLineId)?.autoSort) {
      setError('자동 정렬 기능이 활성화되서 끼어들 수 없습니다.');
      return;
    }
    try {
      await roomAPI.putInterrupt(
        Number(pickLineId),
        Number(nowOrderTurn),
        Number(interruptOrderTurn),
      );
      socketio.entry(Number(pickLineId));
      setModalState(false);
      onListUpdate();
      setConfirm('끼어들기가 완료되었습니다.');
    } catch (err: any) {
      setError('끼어들기에 실패하였습니다.');
    }
  };

  useEffect(() => {
    getEntryLists();
  }, []);

  return (
    <>
      <InputModal
        title="끼어들기"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>현재 순번</h2>
            <CS.TextInputType1
              placeholder="0"
              type="number"
              disabled={true}
              value={nowOrderTurn}
            />
          </li>
          <li>
            <h2>
              끼어들 순번
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.SelectType1>
              <select
                ref={userSelectBoxRef}
                onChange={handleUserSelectBoxChange}
                value={interruptOrderTurn}
              >
                <option value="" disabled={true}>
                  순번을 선택해 주세요.
                </option>
                {interruptOrderTurns?.map((turn, index) => (
                  <option value={turn} key={index}>
                    {turn}
                  </option>
                ))}
              </select>
              <span className="img-box">
                <Icon name="ArrowBottomIcon" size="100%" color="#D8D7DC" />
              </span>
            </CS.SelectType1>
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default Interrupt;
